import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
} from "constants/variables";
import styled from "styled-components";
import cursorIcon from "assets/img/Cursor.png";
import { ReactComponent as ReportsIcon } from "assets/svg/ActivityReportsIcon.svg";
import { ReactComponent as OpenFolderIcon } from "assets/svg/OpenFolderIcon.svg";

export const ActivityReportsContainer = styled.div`
  padding-block: calc(100px + ${SIZE.max80}) 0;
  padding-inline: ${SIZE.max180} ${SIZE.max140};
  display: flex;
  justify-content: space-between;
  column-gap: ${SIZE.max100};

  @media (max-width: 1120px) {
    padding-inline: ${SIZE.max140} ${SIZE.max100};
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    row-gap: ${SIZE.max24};
  }

  @media (max-width: 768px) {
    padding-inline: ${SIZE.max24};
  }
`;

export const LeftSideContainer = styled.div``;

export const TitleSectionWrapper = styled.div``;

export const BackToWrapper = styled.div<{ biggerCursor?: boolean }>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  width: fit-content;
  transition: 0.3s ease-out;
  :hover {
    filter: brightness(0.7);
  }
`;

export const BackToGuidesImage = styled.img`
  margin-right: 8px;
  svg {
    width: 10px;
    height: 16px;
  }
  transform: rotate(90deg);
`;

export const BackToGuidesButton = styled.button`
  background-color: transparent;
  border: none;
  margin-bottom: ${MARGIN.max6};
  cursor: pointer;
`;

export const TitleWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
  display: flex;
  column-gap: ${SIZE.max10};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

export const ActivityReportsRightSideContent = styled.div``;

export const ActivityReportsIconWrapper = styled.div`
  width: fit-content;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ActivityReportsIcon = styled(ReportsIcon)`
  @media (max-width: 350px) {
    width: 70%;
    height: 100%;
  }
`;

export const ActivityReportsContentCardContainer = styled.div`
  width: ${SIZE.max472};

  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.RaisinBlack};
  padding: ${SIZE.max40};
  display: flex;
  flex-direction: column;
  row-gap: ${SIZE.max24};
  max-height: 100%;

  @media (max-width: 1000px) {
    width: auto;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

export const ActivityReportsContentCardTitleWrapper = styled.div``;

export const ActivityReportsContentCardTextWrapper = styled.div``;

export const RightSideContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: ${SIZE.max24};
`;

export const ActivityReportsReportCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${SIZE.max24};
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
`;

export const ReportsSectionReportCardWrapper = styled.a`
  height: ${SIZE.max224};
  aspect-ratio: 1/1;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Cultured};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  // padding-block: ${SIZE.max40} ${SIZE.max55};
  padding: ${SIZE.max40} ${SIZE.max24};
  border: 1px solid ${COLORS.AbsoluteWhite};
  transition: all 0.6s ease-in-out;
  text-decoration: none;
  :hover {
    background-color: ${COLORS.Background};
    cursor: pointer;
  }

  @media (max-width: 950px) {
    height: 19vw;
  }

  @media (max-width: 820px) {
    width: calc(50% - ${SIZE.max24});
    height: auto;
  }
`;
export const ReportsSectionReportCardTitleWrapper = styled.div`
word-wrap: break-word;
max-width: 90%;
display: flex;
align-items: center;
justify-content: center;`;

export const ReportsSectionReportCardIconWrapper = styled.div``;

export const ReportsSectionReportCardIcon = styled(OpenFolderIcon)`
  height: ${SIZE.max55};

  @media (max-width: 1280px) {
    height: ${SIZE.max80};
  }

  @media (max-width: 820px) {
    height: ${SIZE.max160};
  }

  @media (max-width: 768px) {
    width: ${SIZE.max160};
  }

  @media (max-width: 600px) {
    width: auto;
    height: auto;
  }

  ${ReportsSectionReportCardWrapper}:hover & {
    path {
      transition: fill 0.6s ease-in-out;
      fill: ${COLORS.Cultured};
    }
  }
`;

export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: ${SIZE.max32};
`;

export const SvgContainer = styled.div`
  height: auto;
  width: auto;
  margin-bottom: ${MARGIN.max32};
  opacity: 0.4;
  > svg {
    height: ${SIZE.max400};
    width: ${SIZE.max400};
  }
`;
